import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBookingCancellationFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M9.7.5c1 0 1.8.8 1.8 1.8v2.6h-.3a6.3 6.3 0 00-6.17 7.6H2.3c-1 0-1.8-.8-1.8-1.8V2.3c0-1 .8-1.8 1.8-1.8h7.4zM3.55 4.2h4.9c.37 0 .68-.27.68-.6 0-.33-.3-.6-.68-.6h-4.9c-.38 0-.68.27-.68.6 0 .33.3.6.68.6zm-.08 2.7h1.4a.6.6 0 100-1.2h-1.4a.6.6 0 100 1.2zm7.73-.5a4.8 4.8 0 110 9.6 4.8 4.8 0 010-9.6zm1.1 2.75l-1.1 1.13-1.1-1.13a.65.65 0 00-.84-.07l-.09.07a.65.65 0 000 .92l1.12 1.13-1.12 1.14a.65.65 0 10.92.91l1.1-1.12 1.11 1.12c.23.23.58.26.84.08l.08-.07a.65.65 0 000-.92l-1.11-1.14 1.12-1.13a.65.65 0 00-.93-.92z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBookingCancellationFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBookingCancellationFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBookingCancellationFilled svgRef={ref} {...props} />
));
export default ForwardRef;
